"use client";

import React from "react";
import { Wheat, Droplet, Sprout, Award } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const ingredients = [{
  title: "Handmade Tortillas",
  description: "Every morning we press our tortillas by hand using organic heirloom corn for that unmistakable street-style texture.",
  icon: Wheat
}, {
  title: "Local Ingredients",
  description: "We partner with city farmers to source the crispest cilantro, onions, and seasonal peppers for our daily prep.",
  icon: Sprout
}, {
  title: "Secret Salsas",
  description: "Our family recipes are guarded secrets, featuring fire-roasted chiles and a complex blend of traditional spices.",
  icon: Droplet
}, {
  title: "Premium Meats",
  description: "Only the finest cuts of grass-fed beef and heritage pork make it onto our grill for that perfect char and flavor.",
  icon: Award
}];
export default function FreshnessOnWheels() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223996" id="freshness-on-wheels" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20 lg:mb-24">
          <h2 className="font-default text-4xl md:text-5xl lg:text-7xl font-bold tracking-tighter mb-6 uppercase text-primary">
            Freshness on Wheels
          </h2>
          <p className="text-foreground font-sans text-xl md:text-2xl leading-relaxed tracking-normal">
            The Rolling Tacos standard: high-energy street food crafted with premium transparency and the boldest flavors in the city.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-12">
          {ingredients.map((item, i) => <div key={i} data-index={i} className={`flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="mb-8 p-5 rounded-md bg-primary/10 text-primary ring-2 ring-primary shadow-lg shadow-primary/20">
                <item.icon className="size-8 stroke-[2]" />
              </div>
              <h3 className="font-default text-2xl font-bold mb-4 text-primary uppercase tracking-tight">
                {item.title}
              </h3>
              <p className="text-foreground font-sans text-lg leading-relaxed opacity-90">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}